import { createContext, useContext, useEffect, useState, useCallback } from "react";

const ThemeContext = createContext(null);
export const useTheme = () => useContext(ThemeContext);

const KEY = "twp_theme";
const systemDark = () => typeof window !== "undefined" && window.matchMedia && window.matchMedia("(prefers-color-scheme: dark)").matches;

export function ThemeProvider({ children }) {
  // choice: 'light' | 'dark' | null (null = follow system)
  const [choice, setChoice] = useState(() => localStorage.getItem(KEY));
  const [isDark, setIsDark] = useState(() => (localStorage.getItem(KEY) ? localStorage.getItem(KEY) === "dark" : systemDark()));

  useEffect(() => {
    const dark = choice ? choice === "dark" : systemDark();
    setIsDark(dark);
    document.documentElement.classList.toggle("dark", dark);
  }, [choice]);

  useEffect(() => {
    if (choice) return; // explicit choice overrides system
    const mq = window.matchMedia("(prefers-color-scheme: dark)");
    const handler = () => { setIsDark(mq.matches); document.documentElement.classList.toggle("dark", mq.matches); };
    mq.addEventListener("change", handler);
    return () => mq.removeEventListener("change", handler);
  }, [choice]);

  const toggle = useCallback(() => {
    setChoice((prev) => {
      const currentlyDark = prev ? prev === "dark" : systemDark();
      const next = currentlyDark ? "light" : "dark";
      localStorage.setItem(KEY, next);
      return next;
    });
  }, []);

  return <ThemeContext.Provider value={{ isDark, toggle }}>{children}</ThemeContext.Provider>;
}
